import React from 'react';
import dayjs from 'dayjs';
import styled, { useTheme } from 'styled-components/macro';

// components
import { ServiceAdvisorDetails } from '../ServiceAdvisorDetails';
// types
import { InventoryItem } from 'types';
// assets
import { BiLinkExternal } from 'react-icons/bi';

const Content = styled.div`
  width: 800px;
  max-width: 100%;
  margin: 0 auto;
`;

const Row = styled.div`
  display: flex;
  justify-content: center;
  gap: 32px;
  align-items: stretch;
  @media screen and (max-width: 520px) {
    margin-top: -20px;
    display: block;
  }
`;

type ColProps = {
  paddingOnMobile?: string;
};

const Col = styled.div<ColProps>`
  box-sizing: border-box;
  background: ${props => props.theme.colors.white[100]};
  border: 1px solid #eeeff2;
  border-radius: 7px;
  padding: 24px;
  width: 384px;
  max-width: 100%;
  @media screen and (max-width: 520px) {
    border: 0;
    border-radius: 0;
    width: 100%;
    padding: ${props => props.paddingOnMobile};
  }
`;

const Title = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: ${props => props.theme.colors.neutral[80]};
  margin-bottom: 24px;
`;

const Datetime = styled.div`
  font-weight: 800;
  font-size: 14px;
  line-height: 20px;
  color: ${props => props.theme.colors.neutral[100]};
  margin-bottom: 24px;
`;

const Info = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${props => props.theme.colors.neutral[100]};
`;
const ExternalLinkWrapper = styled.a`
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  background: ${props => props.theme.colors.neutral[10]};
  border: 1px solid ${props => props.theme.colors.neutral[20]};
  border-radius: 5px;
  margin-top: 24px;
`;

const Link = styled.div`
  margin-left: 4px;
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.black[100]};
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  border-radius: 5px;
  margin: 32px 0 0;
  @media screen and (max-width: 520px) {
    border-radius: 0;
    margin: 0 0 32px;
  }
`;

type Props = {
  orderDetails: any;
  item?: InventoryItem;
};
export const ScheduledDrive = ({ orderDetails, item }: Props) => {
  const { colors } = useTheme();
  if (!item || !orderDetails) return null;
  const mainImageMedia = !item.media
    ? null
    : item.media.find(m => m.mediaType === 1);
  return (
    <Content
      style={{
        padding: '20px 0',
      }}
    >
      <Row>
        <Col paddingOnMobile='48px 20px 20px 20px'>
          <Title>Test Drive Scheduled</Title>
          <Info>You've successfully requested the test drive for</Info>
          <Datetime>
            {dayjs(orderDetails.scheduledDatetime).format(
              'DD MMMM, YYYY [at] hh:mm a'
            )}
            .
          </Datetime>
          <Info>{item.title} is waiting for you!</Info>
          {item.detailsPageUrl && (
            <ExternalLinkWrapper href={item.detailsPageUrl} target='_blank'>
              <BiLinkExternal size='18px' color={colors.black[100]} />
              <Link>Vehicle Details Page</Link>
            </ExternalLinkWrapper>
          )}
        </Col>
        {!!orderDetails.advisor && (
          <ServiceAdvisorDetails
            advisorDetails={orderDetails.advisor}
            isSales={true}
          />
        )}
      </Row>
      {mainImageMedia && <Image src={mainImageMedia.mediaSource} />}
    </Content>
  );
};
